import { useEffect, useState } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import { UserInfo } from '@/components/common/libraries/types';

export const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  useEffect(() => {
    axios.get<UserInfo>(Routes.plato_api_me_path())
      .then((res) => {
        setUserInfo(res.data);
      })
      .catch(() => {
        setUserInfo(null);
      });
  }, []);

  return userInfo;
};
